module.exports = __webpack_public_path__ + "static/media/pic4.ad0ff7ac.jpg";